import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
import lstore from '@/plugins/lstore/index.js'
import api from '@/api.js'

Vue.use(lstore)
Vue.prototype.$api = api
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
